import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SARSHeader, ErrorModal } from "@soqs/common/";
import Grid from "@mui/material/Unstable_Grid2";
import NavbarButtons from "./Components/NavbarButtonsComponent.jsx";
import Box from "@mui/material/Box";
import OTPVerificationComponent from "./Components/OTPVerificationComponent.jsx";
import SelectOTPMethodComponent from "./Components/SelectOTPMethodComponent.jsx";
import EnterDetailsComponent from "./Components/EnterDetailsComponent.jsx";
import TimelineViewerComponent from "./Components/TimelineViewerComponent.jsx";
import StepperComponent from "./Components/StepperComponent.jsx";
import UserIdentificationComponent from "./Components/UserIdentificationComponent.jsx";

import ScreenLeftImage from "./assets/ScreenLeft.jpg";
import {
  cancelVerification,
  clearErrors,
  currentPage,
  errors,
  getDropdownData,
  getPrepopDataAsync
} from "./features/AppSlice.js";

export const PAGES = {
  UserIdentification: 0,
  EnterDetails: 1,
  SelectOTPMethod: 2,
  VerifyOTP: 3,
  ViewDashboard: 4,
  ConfirmResult: 5,
};

export default function VisualDashboard(props) {
  const dispatch = useDispatch();
  const pageState = useSelector(currentPage);
  const errorState = useSelector(errors);
  const token = new URLSearchParams(window.location.search).get("token");


  useEffect(() => {
    dispatch(getDropdownData());
      if (token) {
        dispatch(
          getPrepopDataAsync(
            token
          )
        );
      }
      return () => {};
  }, [getDropdownData]);

  const ActivePage = (props) => {
    switch (props.page) {
      case PAGES.UserIdentification:
      case PAGES.EnterDetails: {
        return <EnterDetailsComponent />;
      }
      case PAGES.SelectOTPMethod: {
        return <SelectOTPMethodComponent />;
      }
      case PAGES.VerifyOTP: {
        return <OTPVerificationComponent />;
      }
      case PAGES.ViewDashboard: {
        return <TimelineViewerComponent />;
      }
      default: {
        dispatch(cancelVerification());
        break;
      }
    }
  };

  document.body.style.overflow = "hidden";
  document.body.style.margin = "0";

  return (
    <>
      <Grid container /* height={"100vh"} */>
        <Grid item xs={12}>
          <SARSHeader
            onLogoClick={() => {
              dispatch(cancelVerification());
            }}
            pageTitle={"Tax Return Status Dashboard"}
            pageTitleMobile={"Dashboard"}
          />
        </Grid>
        <Grid
          item
          md={4}
          sx={{
            display: { xs: "none", sm: "none", md: "none", lg: "block" },
            height: "88vh",
          }}
        >
          <img
            src={ScreenLeftImage}
            alt="People"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Grid>
        <Grid
          item
          lg={12}
          sm={12}
          xs={12}
          sx={{
            height: "86dvh",
            overflowY: "auto",
            display: { xs: "block", sm: "block", md: "block", lg: "none" },
          }}
        >
          {pageState < 4 ? <StepperComponent /> : null}
          <ActivePage page={pageState} />
        </Grid>
        <Grid
          item
          lg={8}
          sx={{
            height: "83vh",
            overflowY: "auto",
            padding: "1rem 2rem",
            display: { xs: "none", sm: "none", md: "none", lg: "block" },
          }}
        >
          {pageState < 4 ? <StepperComponent /> : null}
          <ActivePage page={pageState} />
        </Grid>
        {pageState === 4 ? (
          <Box
            xs={12}
            style={{
              top: "6.5vh",
              position: "fixed",
              zIndex: "1002",
              right: "3vw",
            }}
          >
            <NavbarButtons />
          </Box>
        ) : null}
        <ErrorModal
          title={
            errorState?.errortitle
              ? errorState?.errortitle
              : typeof errorState?.error === "string" &&
                errorState?.error?.indexOf("|") > -1
              ? errorState?.error?.split("|")[0]
              : "Error"
          }
          open={errorState !== null}
          onClose={() => {
            if (errorState.fatal) {
              dispatch(cancelVerification());
            }
            dispatch(clearErrors());
          }}
          subheader={
            Array.isArray(errorState?.error) ? (
              <ul>
                {errorState?.error.map((e) => (
                  <li>{e}</li>
                ))}
              </ul>
            ) : (
              <p
                dangerouslySetInnerHTML={{
                  __html:
                    errorState?.error?.indexOf("|") > -1
                      ? errorState?.error?.split("|")[1]
                      : errorState?.error,
                }}
              ></p>
            )
          }
        />
      </Grid>
    </>
  );
}
